// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/utenti/selezionabili?societaId=N',
    requestBody: null,
    response: '{"success":"true","data":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/insegne?societaId=N',
    requestBody: null,
    response: '[{"id":"number","nome":"string"}]'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?societaId=N&ruolo=FORNITORE&categoriaFornitore=AGENTE',
    requestBody: null,
    response: '{"data":[...]}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi/prossimo-codice?societaId=N',
    requestBody: null,
    response: '{"codice":"string"}'
  },
  {
    method: 'GET',
    endpoint: '/api/openapi/lookup-azienda?societaId=N&codice=XXX',
    requestBody: null,
    response: '{"success":true,"trovato":true,"data":{...},"fontecache":false}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi',
    requestBody: '{"societaId":"number","tipoSoggetto":"string",...}',
    response: '{"id":"number"}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/abilita-cliente',
    requestBody: '{"categoriaCliente":"string",...}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/abilita-fornitore',
    requestBody: '{"categoriaFornitore":"string",...}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
